import React from 'react';
import { useNavigate } from 'react-router-dom';

function NavBox() {
  const navigate = useNavigate();

  return (
    <div className="nav-box u-margin-top-xxl">
      <div className="nav-box__inner-box">
        <button
          className="btn btn__form"
          onClick={() => {
            navigate('/my-library');
          }}
        >
          Return
        </button>

        <button
          className="btn btn__form"
          onClick={() => {
            navigate('/my-library/my-books');
          }}
        >
          My Books
        </button>
      </div>
    </div>
  );
}

export default NavBox;
